import * as yup from "yup";

export const WSIBCodeSetupValidationSchema = yup.object().shape({
  label: yup.string().required("Label is required"),
  provinceId: yup.string().required("Province is required"),
  // effectiveDate: yup.string().required("Effective Date is required"),
  code: yup.string().required("Code is required"),
});
